import { signIn, signOut, fetchAuthSession, decodeJWT } from 'aws-amplify/auth';
import { CognitoIdentityProviderClient, InitiateAuthCommand } from '@aws-sdk/client-cognito-identity-provider';
import { get, post, put, del } from 'aws-amplify/api';
import { NotificationManager } from './NotificationManager';
import { Amplify } from 'aws-amplify';
const apiName = "Api";

export const signInLink = async (email, password) => {
    try {
        const session = await signIn({username: email, password: password});

        return session;
    } catch(err) {
        console.error("Error al iniciar sesión: ", err);
        throw err;
    }
}

export const signOutLink = async () => {
    try {
        await signOut();
    } catch(err) {
        console.error("Error al cerrar sesión: ", err);
    }
}

export const forgotPassword = async (email) => {
    try {
        const payload = {
            email: email,
            action: "restore"
        }
        // console.log("Payload: ", payload)

        const response = await fetch(`${process.env.REACT_APP_API_URL}/emailCustomizer`, {mode:'cors', method:'POST', headers:{'Content-Type': 'application/json'}, body: JSON.stringify(payload)});
        const resData = await response.json();

        if (!response.ok) {
            throw new Error(resData.message || `Error ${response.status}`);
        }

        return resData;
    } catch(e) {
        console.error("Error al solicitar la recuperación de contraseña: ", e);
        throw e;
    }
}

export const confirmForgotPassword = async (token, newPassword) => {
    try {
        const payload = {
            token: token,
            new_password: newPassword
        }
        // console.log("Payload: ", payload)

        const response = await fetch(`${process.env.REACT_APP_API_URL}/passwordHandler`, {mode:'cors', method:'POST', headers:{'Content-Type': 'application/json'}, body: JSON.stringify(payload)});
        const resData = await response.json();

        if (!response.ok) {
            throw new Error(resData.message || `Error ${response.status}`);
        }

        return resData;
    } catch(e) {
        console.error("Error al confirmar la contraseña: ", e);
        throw e;
    }
}

const getHeaders = async () => {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();
    // console.log(`Auth: Bearer ${token}`)
    return {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    }
    
}

export const authorizedGet = async (path, params={}) => {
    const headers = await getHeaders();
    // console.log("Headers:", headers)
    const operation = get({ apiName, path, options: {
        headers, queryParams: params
    }})

    return await operation.response;    
}

export const authorizedPost = async (path, params={}) => {
    try {
        const headers = await getHeaders();
        const operation = post({ apiName, path, options: {
            headers, body: params
        }})
        const response = await operation.response;

        if (response.statusCode >= 400) {
            throw new Error(response.message || `Error ${response.statusCode}`)
        }

        NotificationManager.push(response.message || "Operación realizada con éxito", true);
        return response;
    } catch(e) {
        NotificationManager.push(e.message || "Ocurrió un error al intentar ejecutar la operación", false);
        throw e;
    }
    
}

export const authorizedPut = async (path, params={}) => {
    try {
        const headers = await getHeaders();
        const operation = put({ apiName, path, options: {
            headers, body: params
        }})
        const response = await operation.response;

        if (response.statusCode >= 400) {
            throw new Error(response.message || `Error ${response.statusCode}`)
        }

        NotificationManager.push(response.message || "Operación realizada con éxito", true);
        return response;
    } catch(e) {
        NotificationManager.push(e.message || "Ocurrió un error al intentar ejecutar la operación", false);
        throw e;
    }
        
}

export const authorizedDelete = async (path, params={}) => {
    try {

        const headers = await getHeaders();
        const operation = del({ apiName, path, options: {
            headers, queryParams: params
        }})
        const response = await operation.response;

        if (response.statusCode >= 400) {
            throw new Error(response.message || `Error ${response.statusCode}`)
        }

        NotificationManager.push(response.message || "Operación realizada con éxito", true);
        return response;
    } catch(e) {
        NotificationManager.push(e.message || "Ocurrió un error al intentar ejecutar la operación", false);
        throw e;
    }
        
}

export const getUserClaims = async () => {
    try {
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken;

        if (idToken) {
            const {payload} = decodeJWT(idToken.toString());
            
            // console.log("Payload obtenido: ", payload);
            return {
                name: payload.name,
                email: payload.email,
                groups: payload['cognito:groups'] || [],
                departments: payload['custom:department'] || [],
                actions: payload['custom:actions'] || []
            };
        }
    } catch(e) {
        console.error("Error al obtener los claims: ", e);
        return null;
    }
}

export const verifyPassword = async (email, password) => {
    const config = Amplify.getConfig();
    const region = config.Auth.Cognito.region;
    const clientId = config.Auth.Cognito.userPoolClientId;

    const client = new CognitoIdentityProviderClient({region});

    const input = { AuthFlow: "USER_PASSWORD_AUTH", ClientId: clientId, AuthParameters: {USERNAME: email, PASSWORD: password}}

    try {
        const command = new InitiateAuthCommand(input);
        const response = await client.send(command);
        // console.log("Response: ", response);

        NotificationManager.push("Identidad confirmada", true);
        return !!(response.AuthenticationResult || response.ChallengeName);

    } catch (err) {
        let msg = "Hubo un error al verificar la contraseña";
        if (err.name === "NotAuthorizedException") {
            msg = "La contraseña es incorrecta"
        } else if (err.name === "LimitExceededException") {
            msg = "Demasiados intentos. Intente más tarde"
        }

        NotificationManager.push(msg, false);
        return false;
    }
}